/**
 * Prefixes the Manning Stats text with "<ACar|DCar> - <session id>". The backend's own
 * text already opens with a bare "ACar"/"DCar" line, which the session-tagged line
 * replaces rather than sits above.
 */
export function withSessionHeader(stats: string, label: 'ACar' | 'DCar', sessionId: string): string {
  const body = stats.replace(/^\s*(?:ACar|DCar)[ \t]*\n+/, '');
  return `${label} - ${sessionId}\n\n${body}`;
}
